import BookingStatus from '../enums/bookingStatus';

const initialState = {
    specId: null,
    additionalHomes: [],
    selectedSlot: null, // this is the default value, the hardcoded value is just for development
     // selectedSlot: {
     //     Date: '/Date(1746066600000)/',
     //     UtcDate: '2025-05-01T02:30:00Z',
     //     SpecTimezoneDate: '2025-05-01T02:30:00+00:00',
     //     SpecTimezoneCode: 'EST',
     //     SpecTimezoneIANAId: 'America/Detroit',
     //     Duration: 30,
     //     IsTourableNow: false
     // },
    questionsResponses: [],
    booking: null,
    bookingStatus: BookingStatus.Pending,
    bookingError: null,
    modalStep: null,
    verificationMethod: null,
    tourableSpecs: [],
    // verificationMethod: 'Jumio', // todo: verify if this is the value we want to use
};

export default initialState;
